import styled from 'styled-components';
import { Row, media } from '@simplywallst/ui-core';

interface ButtonRowProps {
  bottomMargin?: number;
}
export const ButtonRow = styled(Row)<ButtonRowProps>`
  margin: ${({ theme }) => theme.x1spacePx}px 0px;

  ${media.mdUp`
    margin: ${({ theme }) => theme.x2spacePx}px 0px;
  `}

  ${media.lgUp`
  ${({ bottomMargin }) => bottomMargin && `margin-bottom: ${bottomMargin}px`}
  `}
`;

export const ContentWrapper = styled('div')`
  height: ${({ theme }) => theme.x9spacePx}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  > button > svg {
    opacity: 1;
  }

  > p {
    margin-top: ${({ theme }) => theme.x2spacePx}px;
    margin-bottom: 0px;
    ${({ theme }) => theme.typography.tiny}
    > span {
      color: ${({ theme }) => theme.color.warning};
    }
  }
`;
